export default {
  header: {
    notes: 'Header when listing sites',
    message: 'Sites',
  },
  generalInformation: {
    header: {
      notes: 'Header for general information section',
      message: 'General information',
    },
  },
  create: {
    dialogTitle: {
      notes: 'Create site dialog title',
      message: 'Create site',
    },
  },
  model: {
    name: {
      notes: 'Name field for site',
      message: 'Name',
    },
    country: {
      notes: 'Country field for site',
      message: 'Country',
    },
    currency: {
      notes: 'Currency field for site',
      message: 'Currency',
    },
    timeZone: {
      notes: 'Time zone field for site',
      message: 'Time zone',
    },
    locale: {
      notes: 'Locale field for site',
      message: 'Locale',
    },
    company: {
      notes: 'Company field for site',
      message: 'Company',
    },
  },
};
